import { useAppSelector } from "app/store";
import { TaskSuggestionGroup } from "components/task-suggestions/definitions";

export const useGetTaskData = (scanJobId: string): TaskSuggestionGroup[] => {
  const taskData = useAppSelector((state) => state.draftWizard.taskData);
  return scanJobId && taskData[scanJobId]
    ? JSON.parse(JSON.stringify(taskData[scanJobId]))
    : [];
};
